import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import { appContext } from "../../../AppContext";
import { JSX } from "react";
import { Divider } from "@serendie/ui";
import LegacyApiClient from "../../../Providers.Api/LegacyApiClient";
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, RightButtons } from "@iconics/components";

export class DiagnosticsDialog extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            IBSS_API: "",
            IBSS_Data_API: "",
        }
    }

    public componentDidUpdate(prevProps: IProps): void
    {
        if (prevProps.open !== this.props.open && this.props.open)
        {
            this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        const { apiClient } = appContext();
        try
        {
            const version = await LegacyApiClient.getPlatformApiVersion();
            this.setState({ IBSS_API: version });
        }
        catch
        {
            this.setState({ IBSS_API: "" });
        }

        try
        {
            const version = await LegacyApiClient.getDataApiVersion();
            this.setState({ IBSS_Data_API: version });
        }
        catch
        {
            this.setState({ IBSS_Data_API: "" });
        }
    }

    public render(): JSX.Element
    {
        const { labels } = appContext();
        const { settings } = appContext();

        return (
            <Dialog
            isOpen={this.props.open}
            onOpenChange={() => this.props.onClose()}
            lg={4}
            >
                <DialogContent>
                    <Card
                        title={labels.Platform_Diagnostics_Title}
                    >
                        <GridContainer spacing={0}>
                            <GridItem>
                                {`${labels.Platform_Diagnostics_ReleaseVersion} ${settings.externalVersion || labels.funcUnknown_S} \n`}
                            </GridItem>
                            <Divider/>
                            <GridItem>
                                {`MONZA Platform Portal: ${settings.internalVersion || labels.funcUnknown_S} \n`}
                            </GridItem>
                            <GridItem>
                                {`MONZA Platform API: ${this.state.IBSS_API || labels.funcUnknown_S} \n`}
                            </GridItem>
                            <GridItem>
                                {`MONZA Data API: ${this.state.IBSS_Data_API || labels.funcUnknown_S} \n`}
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                onClick={() => this.props.onClose()}
                            >
                                {labels.Platform_CommonAction_Ok}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        );
    }
}

export interface IProps
{
    open: boolean;
    onClose: () => void;
}

export interface IState
{
    IBSS_API: string;
    IBSS_Data_API: string;
}
